import { useState } from "react";
import { navSections } from "@/mocks/guaNews";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <header className="sticky top-0 z-50 bg-background-50/85 backdrop-blur-md border-b border-background-200/70">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          {/* logo */}
          <a href="#top" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-restaurant-fill text-lg"></i>
            </span>
            <h1 className="font-heading text-xl font-bold text-foreground-950 tracking-tight">
              <span className="block">五1吃瓜</span>
              <span className="mt-0.5 block text-[11px] font-medium text-foreground-500">今日爆料 · 一手掌握</span>
            </h1>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navSections.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                <i className={`${n.icon} text-base`}></i>
                {n.label}
              </a>
            ))}
          </nav>

          {/* search + cta */}
          <div className="hidden items-center gap-3 md:flex">
            <div className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100/60 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索今天的热点"
                className="w-36 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 outline-none"
              />
            </div>
            <a
              href="#collection"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              开始吃瓜
            </a>
          </div>

          {/* mobile toggle */}
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-700 md:hidden"
            aria-label="展开菜单"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="border-t border-background-200/70 py-3 md:hidden">
            <div className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100/60 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索今天的热点"
                className="flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 outline-none"
              />
            </div>
            <nav className="mt-2 grid grid-cols-2 gap-1" aria-label="移动端导航">
              {navSections.map((n) => (
                <a
                  key={n.id}
                  href={`#${n.id}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100"
                >
                  <i className={`${n.icon} text-base text-primary-600`}></i>
                  {n.label}
                </a>
              ))}
            </nav>
            <a
              href="#collection"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              开始吃瓜
            </a>
          </div>
        )}
      </div>
    </header>
  );
}